// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_leadContainer__ob36k {
  margin-bottom: 16px;
}

.style_leadDialog__K0VsI .style_dialogTitle__F9rk5 {
  padding-right: 40px;
}

.style_statusChip__KNPEN {
  font-weight: 600;
  border-radius: 4px;
  text-transform: capitalize;
  min-width: 90px;
  padding: 4px 8px;
  display: inline-block;
  text-align: center;
}

.style_new__zCEiM {
  background-color: #E3F2FD;
  color: #1976D2;
}

.style_contacted__r2JTD {
  background-color: #FFF8E1;
  color: #FFA000;
}

.style_qualified__5Eonj {
  background-color: #E8F5E9;
  color: #388E3C;
}

.style_unqualified__QfJ91 {
  background-color: #FFEBEE;
  color: #D32F2F;
}

.style_synced__2JaZq {
  background-color: #E0F7FA;
  color: #0097A7;
}

.style_infoSection__qc89u,
.style_actionsSection__N0mRp,
.style_fieldDataSection__URhJ4 {
  padding: 16px;
  border-radius: 8px;
  background-color: #f9f9f9;
  height: 100%;
}

.style_infoItem__ttj1Z {
  margin-bottom: 8px;
}

.style_additionalFields__shEb4 {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

.style_fieldRow__zOM0c {
  margin-bottom: 8px;
}

.style_fieldLabel__ZM8hH {
  font-weight: 600;
  margin-right: 8px;
}

.style_expandButton__Qakfv {
  transition: transform 0.3s;
}
.style_expandButton__Qakfv.style_expanded__A3q\\+o {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/views/Orders/components/style.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAGE;EACE,mBAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AADF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;EACE,yBAAA;EACA,cAAA;AAFF;;AAKA;;;EAGE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,0BAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,0BAAA;AAFF;AAIE;EACE,yBAAA;AAFJ","sourcesContent":[".leadContainer {\n  margin-bottom: 16px;\n}\n\n.leadDialog {\n  .dialogTitle {\n    padding-right: 40px;\n  }\n}\n\n.statusChip {\n  font-weight: 600;\n  border-radius: 4px;\n  text-transform: capitalize;\n  min-width: 90px;\n  padding: 4px 8px;\n  display: inline-block;\n  text-align: center;\n}\n\n// Status colors\n.new {\n  background-color: #E3F2FD;\n  color: #1976D2;\n}\n\n.contacted {\n  background-color: #FFF8E1;\n  color: #FFA000;\n}\n\n.qualified {\n  background-color: #E8F5E9;\n  color: #388E3C;\n}\n\n.unqualified {\n  background-color: #FFEBEE;\n  color: #D32F2F;\n}\n\n.synced {\n  background-color: #E0F7FA;\n  color: #0097A7;\n}\n\n.infoSection, \n.actionsSection,\n.fieldDataSection {\n  padding: 16px;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  height: 100%;\n}\n\n.infoItem {\n  margin-bottom: 8px;\n}\n\n.additionalFields {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid #eee;\n}\n\n.fieldRow {\n  margin-bottom: 8px;\n}\n\n.fieldLabel {\n  font-weight: 600;\n  margin-right: 8px;\n}\n\n.expandButton {\n  transition: transform 0.3s;\n  \n  &.expanded {\n    transform: rotate(180deg);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leadContainer": `style_leadContainer__ob36k`,
	"leadDialog": `style_leadDialog__K0VsI`,
	"dialogTitle": `style_dialogTitle__F9rk5`,
	"statusChip": `style_statusChip__KNPEN`,
	"new": `style_new__zCEiM`,
	"contacted": `style_contacted__r2JTD`,
	"qualified": `style_qualified__5Eonj`,
	"unqualified": `style_unqualified__QfJ91`,
	"synced": `style_synced__2JaZq`,
	"infoSection": `style_infoSection__qc89u`,
	"actionsSection": `style_actionsSection__N0mRp`,
	"fieldDataSection": `style_fieldDataSection__URhJ4`,
	"infoItem": `style_infoItem__ttj1Z`,
	"additionalFields": `style_additionalFields__shEb4`,
	"fieldRow": `style_fieldRow__zOM0c`,
	"fieldLabel": `style_fieldLabel__ZM8hH`,
	"expandButton": `style_expandButton__Qakfv`,
	"expanded": `style_expanded__A3q+o`
};
export default ___CSS_LOADER_EXPORT___;
